// import { mutations as TYPES } from "./types";
// import { defaultState } from "./state";

const mutations = {
  // [TYPES.TEMPLATE_RESET](state) {
  //   state = defaultState();
  // }
};

export default mutations;
